import React from 'react';
import {
  Layout,
  Page,
  FooterHelp,
} from '@shopify/polaris';

export default function Container({children, pageProps}) {
  return (
    <Page {...pageProps}>
      <Layout>
        {children}

        <Layout.Section>
          <FooterHelp>
            The app is built and managed by <a target="_blank" rel="noopener noreferrer" href="https://www.sunbowlsystems.com">Sunbowl</a>.
          </FooterHelp>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
